export enum TherapieTabsEnum {
    STARTEN = 'STARTEN',
    FORTSETZEN = 'FORTSETZEN'
}

export enum TitrationEventType {
    ParameterChange = "parameter-change",
    PrintPlan = "print-plan",
    CopyRezept = "copy-prescription",
    PrintRezept = "print-prescription",
    ProductSelection = "product-selection",
    PageLoad = "page-load",
    PageReLoad = "page-reload"
}

export interface ITitrationLogParams {
    Name: string;
    Value: any;
}

export interface ITitrationPreLoadParams {
    Fachrichtung: string;
    FachrichtungText: string;
    Bundesland: string;
    BundeslandText: string;
}

export const D_THCKonzentrationStartInput: string = "Extrakt THC 10 mg/mL";
export const D_THCKonzentrationFortInput: string = "Dronabinol 25 mg/mL";

export const D_KolbenpipetteValue: number = 0.05;
export const D_DosierpumpeValue: number = 0.0333333333333333;
